import SectionWithIllustrationAndColor from './section-with-illustration-and-color';

export default SectionWithIllustrationAndColor;
